<template>
  <div class="login-container">
    <el-card class="login-card">
      <div class="login-header">
        <h2>{{ $t('login.title') }}</h2>
        <p>{{ $t('login.subtitle') }}</p>
      </div>
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        label-width="0"
        @keyup.enter.native="handleLogin"
      >
        <el-form-item prop="email">
          <el-input
            v-model="loginForm.email"
            :placeholder="$t('login.emailPlaceholder')"
            prefix-icon="el-icon-message"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            :placeholder="$t('login.passwordPlaceholder')"
            prefix-icon="el-icon-lock"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="loading"
            class="login-btn"
            @click="handleLogin"
          >{{ $t('login.button') }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        email: '',
        password: ''
      },
      loginRules: {
        email: [
          { required: true, message: this.$t('login.emailRequired'), trigger: 'blur' },
          { type: 'email', message: this.$t('login.emailFormat'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('login.passwordRequired'), trigger: 'blur' },
          { min: 6, message: this.$t('login.passwordLength'), trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    // 处理登录
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (!valid) return
        this.loading = true
        this.$store
          .dispatch('login', {
            email: this.loginForm.email,
            password: this.loginForm.password
          })
          .then(() => {
            this.$message.success(this.$t('login.success'))
            this.$router.push('/dashboard')
          })
          .catch(() => {
            this.$message.error(this.$t('login.fail'))
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
.login-card {
  width: 420px;
  border-radius: 10px;
}
.login-header {
  text-align: center;
  margin-bottom: 30px;
}
.login-header h2 {
  margin: 0 0 10px;
  color: #303133;
  font-size: 24px;
}
.login-header p {
  margin: 0;
  color: #909399;
  font-size: 14px;
}
.login-btn {
  width: 100%;
}
</style>
